import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getLoggedUserData } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "UserSignupLinkCreateDrawer",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      drawer: false,
      isCreating: false,
      loggedUserData: {},
      form: {
        name: "",
        utmSource: ""
      },
      rules: {
        required: function required(v) {
          return !!v || "This field is required";
        }
      },
      cancellationToken: null,
      isCopyingToClipboard: false,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isFormValid: function isFormValid() {
      return this.form.name && this.form.name.trim() && this.form.utmSource && this.form.utmSource.trim();
    },
    generatedLink: function generatedLink() {
      return "".concat(window.location.origin, "/subscribe?utm_source=").concat(this.form.utmSource.trim());
    }
  },
  watch: {
    value: function value(newVal) {
      this.drawer = newVal;
    },
    drawer: function drawer(newVal) {
      this.$emit("input", newVal);
    }
  },
  created: function created() {
    this.loggedUserData = getLoggedUserData();
  },
  methods: {
    close: function close() {
      if (!this.isCreating) {
        this.drawer = false;
        this.resetForm();
      }
    },
    sanitizeUtmSource: function sanitizeUtmSource(value) {
      this.form.utmSource = value.toLowerCase().replace(/\s+/g, "_");
    },
    createSignupLink: function createSignupLink() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$cancellationTok;
        var _this, payload;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this2.isFormValid || _this2.isCreating)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this = _this2;
              _this.isCreating = true;
              (_this$cancellationTok = _this.cancellationToken) === null || _this$cancellationTok === void 0 || _this$cancellationTok.cancel();
              _this.cancellationToken = axios.CancelToken.source();
              payload = {
                name: _this.form.name.trim(),
                utmSource: _this.form.utmSource.trim()
              };
              _context.next = 9;
              return request("/v1/users/signup-link", "post", payload, true, "api", null, _this.cancellationToken.token).then(function () {
                _this.isCreating = false;
                _this.$toasted.show("Sign up link created", {
                  type: "success"
                });
                _this.$emit("linkCreated");
                _this.resetForm();
                _this.drawer = false;
              }).catch(function (e) {
                _this.isCreating = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create sign up link.", true);
                handleErrorData(_this, errorData);
                _this.loadings.datatable = false;
                throw e;
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm() {
      this.form = {
        name: "",
        utmSource: ""
      };
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this3 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this3.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    }
  }
};